'use strict';

import keyMirror from 'react/lib/keyMirror';

export default keyMirror({
  UNSUPPORTED_BROWSER: null,

  STAMP_SUBMITTED_TO_ZINE: null,
  STAMP_APPROVED_TO_ZINE: null,
  STAMP_DECLINED_FROM_ZINE: null,
  STAMP_HAS_BEEN_SAVED: null,
  STAMP_HAS_BEEN_DELETED: null,

  ZINE_CREATED: null,
  ZINE_SAVED: null,
  ZINE_DELETED: null,
  ZINE_FOLLOWED: null,

  YOU_CAN_CONTRIBUTE_TO_ZINE: null,
  ACCOUNT_CONNECTED: null,

  INVITE_SENT: null,
  INVITE_SENT_ERROR: null,

  PASSWORD_RESET_CHECK_EMAIL: null,
  PASSWORD_RESET_DONE: null,

  USER_FIRST_EMAIL_NEEDS_CONFIRMATION: null,
  USER_NEW_EMAIL_NEEDS_CONFIRMATION: null,
  USER_EMAIL_RESENT: null,
  USER_EMAIL_CHANGE_CANCELED: null,
  USER_FOLLOWED: null,

  EMAIL_CONFIRMED: null,

  DASHBOARD_COLLECTION_LEARN_MORE: null,
  DASHBOARD_MESSAGE_DECLINED_LEARN_MORE: null,

  WELCOME_FOLLOW_ZINES: null,

  FEEDBACK_SENT: null,

  EMAIL_UNSUBSCRIBE: null,
  EMAIL_RESUBSCRIBED: null,
  EMAIL_UNSUBSCRIBE_ZINE: null,

  INVITATION_ALREADY_USED: null,
  INVITATION_FOR_OTHER_USER: null,

  IMAGE_ADDED_TO_GRABBAG: null,

  DRAFT_FEEDBACK_SENT: null
});


/** WEBPACK FOOTER **
 ** ./constants/NotificationMessages.js
 **/